export default __webpack_public_path__ + "static/media/CompleteCSD.46ae38e1.mp4";